import { gql } from '@/utilities/gql';

export const FAIR_VALUE_HISTORY_GRAPH_NARRATIVE_FRAGMENT = gql(`
  fragment FairValueHistoryGraphNarrativeFields on Narrative @_unmask {
    companyId
    updatedAt
    valuation {
      fairValue
    }
    valuations {
      fairValue
      createdAt
    }
    owner {
      displayName
    }
    company {
      analysisValue {
        lastSharePrice
        return1yAbs
        return7d
        npvPerShare
      }
      data {
        currencyInfo
      }
    }
  }
`);
